import { DeviceError404Animation } from '@northladder/design-system';
import { Text } from '@northladder/i18n';
import { TTextLocalized } from '@northladder/utilities';

interface IPageNotFoundProps {
  ctaText: TTextLocalized;
  onPressCTA: () => void;
  subtitle: TTextLocalized;
  title: TTextLocalized;
}

/**
 * -----------------------------------------------------------------------------
 * This component renders a custom error message for a 404 page.
 */
export function PageNotFound({
  ctaText,
  onPressCTA,
  subtitle,
  title,
}: IPageNotFoundProps) {
  return (
    <div className="mx-auto rounded-2xl bg-white px-4 text-center sm:rounded-lg">
      <div className="mx-auto flex flex-col items-center py-8">
        <DeviceError404Animation className="mx-auto my-12 h-56 w-56" />

        <h1 className="text-primary-700 text-xl font-normal tracking-tight sm:text-xl">
          <Text text={title} />
        </h1>
        <p className="my-8 font-light text-red-900">
          <Text text={subtitle} />
        </p>

        <button
          className="form-btn-secondary text-primary-800 w-auto bg-opacity-60"
          onClick={onPressCTA}
          type="button"
        >
          <Text text={ctaText} />
        </button>
      </div>
    </div>
  );
}
